import { Sku } from '../domain/entities/Sku';
import { NONDISPLAYABLE_STATUSES, InventoryStatus } from '../constants/InventoryStatuses';

export const isSkuDisplayable = (sku: Sku) => {
    return NONDISPLAYABLE_STATUSES.indexOf(InventoryStatus.valueOf(sku.inventoryStatus)) === -1;
};
